import {HttpError} from '../../../network/errors/HttpError'
import {InputError} from '../components/MeetingCommentInputForm'
import EventEmitterEx from '../../shared/pageBaseComponents/EventEmitterEx'
import {Nullable} from '../../../app/TypeHelpers'
import {SubmitCommentAndFilesTemplate} from './SubmitCommentAndFilesTemplate'
import {FileDataForValidate} from './FileDataForValidate'

export abstract class SubmitCommentAndFilesTemplateForResident<S> extends SubmitCommentAndFilesTemplate<S> {
    protected constructor(
        registerCommentError: (inputError: InputError) => void,
        eventEmitter: EventEmitterEx,
    ) {
        super(registerCommentError, eventEmitter)
    }

    abstract innerRegisterComment(sendData: S): Promise<Nullable<number>>

    abstract innerValidateFile(fileDataForValidate: FileDataForValidate): Promise<Nullable<void>>

    async registerComment(sendData: S): Promise<Nullable<number>> {
        let commentId: Nullable<number> = null
        try {
            commentId = await this.innerRegisterComment(sendData)
        } catch (e) {
            const errorMessages = this.getErrorMessages((e as HttpError).responseBody)
            this.registerCommentError({
                title: 'コメントを登録できませんでした。',
                messages: errorMessages,
            })
        }
        return commentId
    }

    async validateFile(fileDataForValidate: FileDataForValidate): Promise<Nullable<void>> {
        let result: Nullable<void> = null
        try {
            result = await this.innerValidateFile(fileDataForValidate)
        } catch (e) {
            const errorFileNames = this.getErrorFileNames((e as HttpError).responseBody, fileDataForValidate)
            this.registerCommentError({
                title: 'コメントを登録できませんでした。',
                messages: ['ファイル名に機種依存文字が使用されています。', 'ファイル名を変更し、資料の追加をやり直してください。'],
                fileNameList: errorFileNames,
            })
        }
        return result
    }
}
